export default __webpack_public_path__ + "static/media/testcase.28287f7b.png";